(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8126,9294],{

/***/ 30553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = (0,_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(control, controlProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel));

/***/ }),

/***/ 37702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuItem_MenuItem; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(66987);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/react.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = (0,objectWithoutProperties/* default */.Z)(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = react.useContext(ListContext/* default */.Z);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = react.useRef(null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  var children = react.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && (0,isMuiElement/* default */.Z)(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = react.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = react_dom.findDOMNode(instance);
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(handleOwnRef, ref);

  var componentProps = (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase/* default */.Z;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/react.createElement(ListContext/* default.Provider */.Z.Provider, {
      value: childContext
    }, /*#__PURE__*/react.createElement(ContainerComponent, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/react.createElement(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/react.createElement(ListContext/* default.Provider */.Z.Provider, {
    value: childContext
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: handleRef
  }, componentProps), children));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItem_ListItem = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiListItem'
})(ListItem));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js








var MenuItem_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.Z)({}, theme.typography.body1, (0,defineProperty/* default */.Z)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/react.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react.createElement(ListItem_ListItem, (0,esm_extends/* default */.Z)({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: (0,esm_extends/* default */.Z)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx_m/* default */.Z)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var MenuItem_MenuItem = ((0,withStyles/* default */.Z)(MenuItem_styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),

/***/ 24691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio_Radio; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/internal/SwitchBase.js
var SwitchBase = __webpack_require__(56608);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonUnchecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonUnchecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonChecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonChecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/RadioButtonIcon.js






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/react.createElement("div", {
    className: (0,clsx_m/* default */.Z)(classes.root, checked && classes.checked)
  }, /*#__PURE__*/react.createElement(RadioButtonUnchecked, {
    fontSize: fontSize
  }), /*#__PURE__*/react.createElement(RadioButtonChecked, {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js

/**
 * @ignore - internal component.
 */

var RadioGroupContext = react.createContext();

if (false) {}

/* harmony default export */ var RadioGroup_RadioGroupContext = (RadioGroupContext);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js


function useRadioGroup() {
  return react.useContext(RadioGroup_RadioGroupContext);
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js













var Radio_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, {
  checked: true
});
var defaultIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, null);
var Radio = /*#__PURE__*/react.forwardRef(function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = (0,createChainedFunction/* default */.Z)(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/react.createElement(SwitchBase/* default */.Z, (0,esm_extends/* default */.Z)({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/react.cloneElement(defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    classes: {
      root: (0,clsx_m/* default */.Z)(classes.root, classes["color".concat((0,capitalize/* default */.Z)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Radio_Radio = ((0,withStyles/* default */.Z)(Radio_styles, {
  name: 'MuiRadio'
})(Radio));

/***/ }),

/***/ 32554:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonChecked');

exports.Z = _default;

/***/ }),

/***/ 85311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

exports.Z = _default;

/***/ }),

/***/ 22047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86788);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var StyledSwiper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "Carousel__StyledSwiper", componentId: "sc-1rkz4rr-0" })(["position:relative;min-width:100%;"]);



var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].a.withConfig({ displayName: "Carousel__Button", componentId: "sc-1rkz4rr-1" })(["width:48px;height:48px;line-height:48px;border:solid 1px rgb(234,234,234);background-color:transparent;position:absolute;top:50%;margin-top:-24px;display:block;cursor:pointer;z-index:2;text-align:center;color:", ";&:before{font-size:18px;font-weight:bold;}@media (max-width:1405px){background-color:#ffffff;color:black;border:0;}&.disabled{display:none;}", ";&.next{left:auto;right:", ";@media (max-width:1405px){right:20px;}}&.previous{right:auto;left:", ";transform:rotate(180deg);@media (max-width:1405px){left:20px;}}@media (max-width:", "){display:none;}"],














function (props) {return props.theme.colors.neutrals.gray;},
















function (props) {return (
    props.controllersIn ? "\n          background-color: rgba(0, 0, 0, 0.6);\n          color: white;\n          border: 0;\n        " :





    null);},



function (props) {return props.controllersIn ? '20px' : '-70px';},








function (props) {return props.controllersIn ? '20px' : '-70px';},







function (props) {return "".concat(props.theme.viewports.mobile, "px");});












var Carousel = function Carousel(props) {var _props$spaceBetween, _props$spaceBetween2;
  var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var className = props.className;
  var sectionId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Date.now().toString(16));
  var prevClassname = "swiper-custom-previous-".concat(sectionId.current);
  var nextClassname = "swiper-custom-next-".concat(sectionId.current);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    swiperRef.current.slideTo(props.activeSlideIndex);
  }, [props.activeSlideIndex]);

  var itemPerView = props.itemPerView || 4;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledSwiper, { className: className, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
          style: { height: 'max-content' },
          onSwiper: function onSwiper(swiper) {
            swiperRef.current = swiper;
          },
          modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Lazy */ .oM, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr],
          spaceBetween: 30,
          slidesPerView: 1,
          slidesPerGroup: 1,
          navigation: {
            prevEl: ".".concat(prevClassname),
            nextEl: ".".concat(nextClassname),
            disabledClass: 'disabled' },

          loop: props.loopSlider,
          breakpoints: {
            1240: {
              slidesPerView: itemPerView,
              spaceBetween: (_props$spaceBetween = props.spaceBetween) !== null && _props$spaceBetween !== void 0 ? _props$spaceBetween : 30 },

            1024: {
              slidesPerView: 3,
              spaceBetween: (_props$spaceBetween2 = props.spaceBetween) !== null && _props$spaceBetween2 !== void 0 ? _props$spaceBetween2 : 30 },

            768: {
              slidesPerView: 2,
              spaceBetween: 20 },

            250: {
              slidesPerView: 1,
              spaceBetween: 15 } }, children:



          react__WEBPACK_IMPORTED_MODULE_0__.Children.map(props.children, function (child, i) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, { children: child }, i));}) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Button, {
          className: "next ygb-icon-slider_arrow ".concat(nextClassname),
          controllersIn: props.controllersIn }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Button, {
          className: "previous ygb-icon-slider_arrow ".concat(prevClassname),
          controllersIn: props.controllersIn })] }) }));




};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 87977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["data-testid"];















var EmptyResults = function EmptyResults(_ref) {var _ref$dataTestid = _ref[
  'data-testid'],dataTestId = _ref$dataTestid === void 0 ? 'EmptyResults' : _ref$dataTestid,
  props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);return /*#__PURE__*/(

    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      className: props.className,
      my: "50px",
      flexDirection: "column",
      alignItems: "center", children: [/*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "30px", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { name: props.icon, fontSize: "84px", color: "#7D7D7D;" }),
        props.children && props.children] }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsText */ .xM, { children: props.title }) }),

      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsDescription */ .ZE, { children: props.description }) }) :

      null,
      props.action ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsTextAction */ .aC, { children: props.action }) }) :

      null,
      props.button ? props.button : null] }));};



/* harmony default export */ __webpack_exports__["Z"] = (EmptyResults);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 70300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .H2SectionHeader */ .L0).withConfig({ displayName: "SectionHeader__Header", componentId: "sc-j2xtiu-0" })(["", ""],
_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .sectionTitleStyle */ .d1);











var SectionHeader = function SectionHeader(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        className: props.className,
        justifyContent: "space-between",
        alignItems: "center", children: [/*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Header, { className: "SectionHeader--H2SectionHeader", children:
            props.title }),

          props.subTitle && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, _objectSpread(_objectSpread({},
          props.subTitleStyle ?
          { customStyle: props.subTitleStyle } :
          {}), {}, { children:

            props.subTitle })),


          props.secondSubtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, { children: props.secondSubtitle })] }),

        props.button ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flexShrink: 0, ml: [40, 40, 0], children:
          props.button }) :

        null] }) }));};




/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);

/***/ }),

/***/ 64370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var TextWithIcon = function TextWithIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      mx: "-5px",
      alignItems: "center",
      justifyContent: props.rightSideIcon ? 'space-between' : 'normal',
      style: { width: props.rightSideIcon ? '100%' : 'auto' },
      className: props.className, children: [

      props.rightSideIcon ? null : /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          name: props.icon,
          color: props.iconColor,
          fontSize: props.iconSize,
          style: { verticalAlign: 'middle' } }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "p",
        mx: "5px",
        style: { textTransform: props.uppercase ? 'uppercase' : 'inherit' }, children:

        props.children }),

      props.rightSideIcon ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          name: props.icon,
          color: props.iconColor,
          fontSize: props.iconSize }) }) :


      null] }));};



/* harmony default export */ __webpack_exports__["Z"] = (TextWithIcon);

/***/ }),

/***/ 94997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image; },
/* harmony export */   "Xd": function() { return /* binding */ BackgroundImage; }
/* harmony export */ });
/* unused harmony export Ratio */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
var _excluded = ["className", "objectFit"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Image = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].img.withConfig({ displayName: "ThumbnailWithRatio__Image", componentId: "sc-pg90bj-0" })(["position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"]);








var Ratio = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "ThumbnailWithRatio__Ratio", componentId: "sc-pg90bj-1" })(["position:relative;padding-top:", ";"],

function (props) {return props.ratio ? props.ratio : '56.25%';});


var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "ThumbnailWithRatio__BackgroundImage", componentId: "sc-pg90bj-2" })(["width:100%;height:auto;position:absolute;top:0;left:0;bottom:0;right:0;background-size:cover;background-position:center;width:100%;height:100%;box-shadow:", ";", ";", ";", ";"],












function (props) {return (
    props.shadow && "inset 0px -112px 68px -64px rgba(0,0,0,0.75)");},
function (props) {return (
    props.withRadius && (
    props.large ? "\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n          border-top-left-radius: 5px;\n          border-bottom-left-radius: 5px;\n          @media (max-width: ".concat(





    props.theme.viewports.mobile, "px) {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n            border-top-left-radius: 5px;\n            border-top-right-radius: 5px;\n          }\n        ") : "\n          border-bottom-right-radius: 0;\n          border-bottom-left-radius: 0;\n          border-top-left-radius: 5px;\n          border-top-right-radius: 5px;\n        "));},












function (props) {return (
    props.isProgram ? "\n          border-radius: 3px;\n        " :



    null);},
function (props) {return (
    props.isLocked ? "\n          overflow: hidden;\n          &:before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            opacity: 0.8;\n            background-color: #9dc9c7;\n          }\n          &:after {\n            font-family: 'ygb-font' !important;\n            speak: none;\n            font-style: normal;\n            font-weight: normal;\n            font-variant: normal;\n            text-transform: none;\n            z-index: 1;\n            /* Better Font Rendering =========== */\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            content: '\\e94b';\n            height: 24px;\n            width: 24px;\n            color: white;\n            position: absolute;\n            top: calc(50% - 12px);\n            left: calc(50% - 12px);\n            text-align: center;\n            line-height: 24px;\n          }\n        " :


































    null);});


var PLACEHOLDER_IMAGE =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcWw8AAf8BPlp9PLwAAAAASUVORK5CYII=';

var ThumbnailWithRatio = function ThumbnailWithRatio(_ref)



{var _ref$className = _ref.className,className = _ref$className === void 0 ? null : _ref$className,_ref$objectFit = _ref.objectFit,objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Ratio, { className: className, ratio: props.ratio, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Image, {
        src: props.path || PLACEHOLDER_IMAGE,
        objectFit: objectFit,
        loading: "lazy" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BackgroundImage, _objectSpread(_objectSpread(_objectSpread({},
      props),
      props.isLocked ? { 'data-locked': true } : {}), {}, { children:

        props.children }))] }));



};

ThumbnailWithRatio.toString = Ratio.toString;

/* harmony default export */ __webpack_exports__["ZP"] = (ThumbnailWithRatio);

/***/ }),

/***/ 67095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85169);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_ConfirmDeletePlaylistModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92913);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47493);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var ButtonDeletePlaylist = function ButtonDeletePlaylist(props) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_3__/* .UserContext */ .S),currentUser = _useContext[0],_useContext$ = _useContext[1],loading = _useContext$.loading,error = _useContext$.error;
  var _useState =


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),confirmDeletePlaylistModalOpen = _useState[0],setConfirmDeletePlaylistModalOpen = _useState[1];

  if (error) return null;

  var DynamicComponent = props.tag;
  if (loading) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DynamicComponent, { disabled: loading, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "metadata.please_wait", message: "Please wait..." }) }));


  }

  if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== props.playlist.ownerId) {
    return null;
  }

  if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DynamicComponent, {
          onClick: function onClick() {
            setConfirmDeletePlaylistModalOpen(true);
          }, children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { icon: "ygb-icon-trash", iconSize: "15px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "metadata.delete_playlist", message: "Delete Playlist" }) }) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_organisms_modals_ConfirmDeletePlaylistModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          open: confirmDeletePlaylistModalOpen,
          handleClose: function handleClose() {
            setConfirmDeletePlaylistModalOpen(false);
          },
          playlistTitle: props.playlist.title,
          playlistVideoCount: props.playlist.videoCount,
          playlistId: props.playlist.id })] }));



  }

  return null;
};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonDeletePlaylist);

/***/ }),

/***/ 43379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77495);
/* harmony import */ var _organisms_modals_PlaylistModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24331);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47493);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






var ButtonEditPlaylist = function ButtonEditPlaylist(props) {
  var DynamicComponent = props.tag;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext[0],loading = _useContext[1].loading;

  if (loading) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicComponent, _objectSpread(_objectSpread({}, props), {}, { disabled: loading, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.please_wait", message: "Please wait..." }) })));


  }
  if (currentUser && currentUser.id !== props.playlist.ownerId) {
    return null;
  }
  if (!(currentUser !== null && currentUser !== void 0 && currentUser.id)) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { children:
        function children(handleOpenModal) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicComponent, _objectSpread(_objectSpread({}, props), {}, { onClick: handleOpenModal, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.login", message: "Login" }) })));} }));




  } else if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_organisms_modals_PlaylistModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { playlist: props.playlist, children:
        function children(handleOpenModal) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicComponent, _objectSpread(_objectSpread({}, props), {}, { onClick: handleOpenModal, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { icon: "ygb-icon-edit", iconSize: "15px", children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.edit_playlist", message: "Edit Playlist" }) }) })));} }));





  }
};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonEditPlaylist);

/***/ }),

/***/ 21158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PlaylistFavoriting; },
/* harmony export */   "l": function() { return /* binding */ VideoFavoriting; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17674);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12922);
/* harmony import */ var _lib_apollo_policies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54734);
/* harmony import */ var _lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73074);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47493);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48354);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);
var _excluded = ["videoId"],_excluded2 = ["playlistId"];var _templateObject;function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}









var GET_CURRENT_USER_FAVORITES = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n  query currentUser {\n    currentUser {\n      id\n      favorites {\n        playlists\n        videos\n      }\n    }\n  }\n"])));











/**
 * The Logic of these 4's should be refactored
 */
var updateUnfavoriteVideo = function updateUnfavoriteVideo(proxy, videoId) {
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          videos: data.currentUser.favorites.videos.filter(
          function (id) {return id !== videoId;}) }) }) } });





};

var updateFavoriteVideo = function updateFavoriteVideo(proxy, videoId) {
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          videos: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data.currentUser.favorites.videos), [videoId]) }) }) } });




};

var updateUnfavoritePlaylist = function updateUnfavoritePlaylist(
proxy,
playlistId)
{
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          playlists: data.currentUser.favorites.playlists.filter(
          function (id) {return id !== playlistId;}) }) }) } });





};

var updateFavoritePlaylist = function updateFavoritePlaylist(
proxy,
playlistId)
{
  var data = proxy.readQuery({
    query: GET_CURRENT_USER_FAVORITES });


  proxy.writeQuery({
    query: GET_CURRENT_USER_FAVORITES,
    data: {
      currentUser: _objectSpread(_objectSpread({},
      data.currentUser), {}, {
        favorites: _objectSpread(_objectSpread({},
        data.currentUser.favorites), {}, {
          playlists: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data.currentUser.favorites.playlists), [playlistId]) }) }) } });




};

var VideoFavoriting = function VideoFavoriting(_ref) {var _currentUser$favorite, _currentUser$favorite2;var videoId = _ref.videoId,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref, _excluded);
  var _useLoginModal = (0,_lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}),_useLoginModal2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useLoginModal, 2),loginModalContent = _useLoginModal2[0],openModal = _useLoginModal2[1].openModal;
  var _useDeleteFavoriteVid =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useDeleteFavoriteVideoMutation */ .ygI)(),_useDeleteFavoriteVid2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useDeleteFavoriteVid, 2),deleteFavoriteVideo = _useDeleteFavoriteVid2[0],deleteFavoriteVideoLoading = _useDeleteFavoriteVid2[1].loading;
  var _useAddFavoriteVideoM =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useAddFavoriteVideoMutation */ .Gxw)(),_useAddFavoriteVideoM2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useAddFavoriteVideoM, 2),addFavoriteVideo = _useAddFavoriteVideoM2[0],addFavoriteVideoLoading = _useAddFavoriteVideoM2[1].loading;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext[0],_useContext$ = _useContext[1],loading = _useContext$.loading,error = _useContext$.error;

  if (error || loading || currentUser === undefined) {
    return null;
  }

  var handlingFavoritingVideo = /*#__PURE__*/function () {var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(
    isFavoritedVideoById,
    addFavoriteVideo,
    deleteFavoriteVideo) {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!

              isFavoritedVideoById) {_context.next = 5;break;}_context.next = 3;return (
                deleteFavoriteVideo({
                  variables: {
                    videoId: videoId },

                  // TODO: handle failed case
                  update: function update(proxy) {return updateUnfavoriteVideo(proxy, videoId);} }));case 3:_context.next = 8;break;case 5:


              (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().sendVideoAddedToFavorites({ video_id: videoId });

              // TODO: handle failed case
              _context.next = 8;return addFavoriteVideo({
                variables: {
                  videoId: videoId },

                // TODO: handle failed case
                update: function update(proxy) {
                  updateFavoriteVideo(proxy, videoId);
                } });case 8:case "end":return _context.stop();}}}, _callee);}));return function handlingFavoritingVideo(_x, _x2, _x3) {return _ref2.apply(this, arguments);};}();




  var isFavoritedVideoById = currentUser ?
  currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$favorite = currentUser.favorites) === null || _currentUser$favorite === void 0 ? void 0 : (_currentUser$favorite2 = _currentUser$favorite.videos) === null || _currentUser$favorite2 === void 0 ? void 0 : _currentUser$favorite2.includes(videoId) :
  false;

  var onClickFavoriteHandler = /*#__PURE__*/function () {var _ref3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (
              currentUser) {_context2.next = 4;break;}
              openModal();_context2.next = 7;break;case 4:_context2.next = 6;return (

                handlingFavoritingVideo(
                isFavoritedVideoById,
                addFavoriteVideo,
                deleteFavoriteVideo));case 6:

              (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_3__/* .snackbarVar */ .Ck)({
                isSnackBarOpen: true,
                goTo: 'FAVORITES',
                id: 'favorites_2',
                snackBarMessage: isFavoritedVideoById ? /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.unfavorited_video") : /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.favorited_video") });case 7:case "end":return _context2.stop();}}}, _callee2);}));return function onClickFavoriteHandler() {return _ref3.apply(this, arguments);};}();




  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, { children: [
      loginModalContent,
      props.children({
        isFavoritedVideoById: isFavoritedVideoById,
        onClickFavoriteHandler: onClickFavoriteHandler,
        loading: deleteFavoriteVideoLoading || addFavoriteVideoLoading })] }));



};

var PlaylistFavoriting = function PlaylistFavoriting(_ref4) {var _currentUser$favorite3;var playlistId = _ref4.playlistId,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref4, _excluded2);
  var _useLoginModal3 = (0,_lib_hooks_useLoginModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}),_useLoginModal4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useLoginModal3, 2),loginModalContent = _useLoginModal4[0],openModal = _useLoginModal4[1].openModal;
  var _useDeleteFavoritePla =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useDeleteFavoritePlaylistMutation */ .w3$)(),_useDeleteFavoritePla2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useDeleteFavoritePla, 2),deleteFavoritePlaylist = _useDeleteFavoritePla2[0],deleteFavoritePlaylistLoading = _useDeleteFavoritePla2[1].loading;
  var _useAddFavoritePlayli =


  (0,_gql_generated__WEBPACK_IMPORTED_MODULE_6__/* .useAddFavoritePlaylistMutation */ .pAI)(),_useAddFavoritePlayli2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useAddFavoritePlayli, 2),addFavoritePlaylist = _useAddFavoritePlayli2[0],addFavoritePlaylistLoading = _useAddFavoritePlayli2[1].loading;
  var _useContext2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext2[0],_useContext2$ = _useContext2[1],loading = _useContext2$.loading,error = _useContext2$.error;

  if (error || loading) {
    return null;
  }

  var handlingFavoritingPlaylist = /*#__PURE__*/function () {var _ref5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(
    isPlaylistFavoritedById,
    addFavoritePlaylist,
    deleteFavoritePlaylist) {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:if (!

              isPlaylistFavoritedById) {_context3.next = 5;break;}_context3.next = 3;return (

                deleteFavoritePlaylist({
                  variables: {
                    playlistId: playlistId },

                  // TODO: handle failed case
                  update: function update(proxy) {return updateUnfavoritePlaylist(proxy, playlistId);} }));case 3:_context3.next = 8;break;case 5:


              (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().sendPlaylistAddedToFavorites({
                playlist_id: playlistId });

              // PLAYLIST TODO: handle errors
              _context3.next = 8;return addFavoritePlaylist({
                variables: {
                  playlistId: playlistId },

                // TODO: handle failed case
                update: function update(proxy) {
                  updateFavoritePlaylist(proxy, playlistId);
                } });case 8:case "end":return _context3.stop();}}}, _callee3);}));return function handlingFavoritingPlaylist(_x4, _x5, _x6) {return _ref5.apply(this, arguments);};}();




  var isPlaylistFavoritedById = currentUser ?
  currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$favorite3 = currentUser.favorites) === null || _currentUser$favorite3 === void 0 ? void 0 : _currentUser$favorite3.playlists.includes(playlistId) :
  false;

  var onClickFavoriteHandler = /*#__PURE__*/function () {var _ref6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (
              currentUser) {_context4.next = 4;break;}
              // show login modal
              openModal();_context4.next = 7;break;case 4:_context4.next = 6;return (

                handlingFavoritingPlaylist(
                isPlaylistFavoritedById,
                addFavoritePlaylist,
                deleteFavoritePlaylist));case 6:


              (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_3__/* .snackbarVar */ .Ck)({
                isSnackBarOpen: true,
                goTo: 'FAVORITES',
                id: 'favorites_1',
                snackBarMessage: isPlaylistFavoritedById ? /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.unfavorited_playlist") : /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_15__/* .i18n._ */ .ag._("snackbars.favorited_playlist") });case 7:case "end":return _context4.stop();}}}, _callee4);}));return function onClickFavoriteHandler() {return _ref6.apply(this, arguments);};}();




  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, { children: [
      loginModalContent,
      props.children({
        isPlaylistFavoritedById: isPlaylistFavoritedById,
        onClickFavoriteHandler: onClickFavoriteHandler,
        loading: deleteFavoritePlaylistLoading || addFavoritePlaylistLoading })] }));



};

/***/ }),

/***/ 5822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37702);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_ShareModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["className"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}














var MenuItemShareModal = function MenuItemShareModal(props, ref) {
  var className = props.className,otherProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_organisms_modals_ShareModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, otherProps), {}, { children:
      function children(handleOpenModal) {return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { ref: ref, onClick: handleOpenModal, children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              className: className,
              icon: "ygb-icon-share",
              iconSize: "15px", children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "menu_more.share", message: "Share" }) }) }));} })));





};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(MenuItemShareModal));

/***/ }),

/***/ 43012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QB": function() { return /* binding */ items6; },
/* harmony export */   "dz": function() { return /* binding */ items10; },
/* harmony export */   "gE": function() { return /* binding */ items2; },
/* harmony export */   "l6": function() { return /* binding */ items5; },
/* harmony export */   "u7": function() { return /* binding */ items3; }
/* harmony export */ });
/* unused harmony exports items8, items4, taxonomies, CollectionCardMeta, CourseCardMeta, PlaylistCardMeta, VideoCardMeta, BlogItemCardMeta, RelatedVideoMeta, InstructorMeta, ResultArticleMeta, ResultUserMeta, ResultPositionMeta */
var items10 = Array.from(Array(10).keys());
var items8 = Array.from(Array(8).keys());
var items6 = Array.from(Array(6).keys());
var items5 = Array.from(Array(5).keys());
var items4 = Array.from(Array(4).keys());
var items3 = Array.from(Array(3).keys());
var items2 = Array.from(Array(2).keys());

var taxonomies = [
{
  name: 'Styles',
  open: false,
  terms: [
  { name: 'Hatha', important: true, selected: false },
  { name: 'Yin yoga', important: true, selected: false },
  { name: 'Partner yoga', selected: false },
  { name: 'Student yoga', selected: false },
  { name: 'Yoyo yoga', selected: false },
  { name: 'Something yoga', selected: false },
  { name: 'Bla yoga', selected: false },
  { name: 'Work yoga', selected: false },
  { name: 'Royce yoga', selected: false },
  { name: 'Marshall yoga', selected: false },
  { name: 'Twitter yoga', selected: false },
  { name: 'Fb yoga', selected: false },
  { name: 'Ko yoga', selected: false },
  { name: 'Lo yoga', selected: false },
  { name: 'Po yoga', selected: false },
  { name: 'Yaou yoga', selected: false }] },


{
  name: 'Duration',
  open: false,
  terms: [
  { name: '5 minutes', selected: false },
  { name: '15 minutes', selected: false }] },


{
  name: 'Something',
  open: false,
  terms: [{ name: 'Test', selected: false }] },

{
  name: 'Something 2',
  open: false,
  terms: [{ name: 'Test again', selected: false }] },

{
  name: 'Something 3',
  open: false,
  terms: [{ name: 'Test again again', selected: false }] }];



var CollectionCardMeta = {
  name: 'For athletes',
  thumbnailUrl: 'http://via.placeholder.com/300x295' };


var CourseCardMeta = {
  title: 'Fall asleep - Yoga Nidra',
  secondTitle: 'YOMI Yin online',
  description:
  'Kom ner i varv och hjälp kroppen att somna gott. de förberedande positionerna hjälper dig komma ner i varv och hitta in i kroppen innan du guidas in i yoga nidra, yogisk sömn, för total avslappning',
  thumbnailUrl: 'http://via.placeholder.com/500x500' };


var PlaylistCardMeta = {
  title: 'Fall asleep - Yoga Nidra',
  description:
  'Kom ner i varv och hjälp kroppen att somna gott. de förberedande positionerna hjälper dig komma ner i varv och hitta in i kroppen innan du guidas in i yoga nidra, yogisk sömn, för total avslappning',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  duration: 30,
  videoCount: 2,
  createdBy: 'Yogobe' };


var VideoCardMeta = {
  title: 'Yogalärartips: Passning i hunden för nybörjare',
  description:
  'Ett bra ställe att börja hela om vi kommit ur balans är hur viförhåller oss till oss själva',
  duration: 5,
  favorite: false,
  instructorName: 'Johanna Alvin',
  genre: 'Yin',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  videoSlug: '/test1',
  instructorSlug: '/instructor1',
  genreSlug: '/genre1' };


var BlogItemCardMeta = {
  title: '12 veckor till milen',
  description:
  'Kom igång med din löpträning! Magnus Hagström guidar dig mot målet att kunna springa 1 mil om 12 veckor. Ett program för alla som vill bygga upp en hållbar löpträning!',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  blogUrl: '' };


var RelatedVideoMeta = {
  name: 'Teknik asana: Eka Pada Galavasana / Fly lol hi something else?',
  description: 'Teknik för armbalans som stärker armar, axlar & core',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  videoUrl: '/test',
  duration: 5 };


var InstructorMeta = {
  firstName: 'Johanna',
  lastName: 'Alvin',
  description:
  'Johanna är i grunden idrottslärare och har de flesta instruktörsutbildningar inom gymvärlden i ryggen. Numera jobbar hon dock med yoga på heltid. Hon driver studion FLOW i Göteborg, jobbar med PT-kunder, håller workshops, kurser ...',
  thumbnailUrl: 'http://via.placeholder.com/60x60',
  instructorUrl: '/test' };


var ResultArticleMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  title: 'Ärtpesto – familjens nya middagsfavorit' };


var ResultUserMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  name: 'Dianne Ameter' };


var ResultPositionMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  title: 'Title',
  english_title: 'English title',
  local_language_title: 'local_language_title' };

/***/ }),

/***/ 73074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77495);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["open"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var useLoginModal = function useLoginModal()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open),isOpen = _useState[0],setOpen = _useState[1];

  var content = /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, { open: isOpen, onClose: function onClose() {return setOpen(false);} }));


  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ __webpack_exports__["Z"] = (useLoginModal);

/***/ }),

/***/ 8033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var _components_Carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22047);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var BasicCarouselCard = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "Carousel__BasicCarouselCard", componentId: "sc-1ydziwj-0" })(["@media (max-width:", "){&.swiper-slide-prev,&:first-of-type{margin-left:20px;}&:first-of-type.swiper-slide-prev{margin-left:40px;}}@media (max-width:", "){max-width:270px;&.swiper-slide-prev,&:first-of-type{margin-left:15px;}&:first-of-type.swiper-slide-prev{margin-left:30px;}}"],
function (props) {return "".concat(props.theme.viewports.tablet, "px");},










function (props) {return "".concat(props.theme.viewports.mobile, "px");});













var CarouselItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BasicCarouselCard).withConfig({ displayName: "Carousel__CarouselItem", componentId: "sc-1ydziwj-1" })(["max-width:", ";"],
function (p) {return p.maxWidth ? "".concat(p.maxWidth, "px") : "407px";});


var Carousel = function Carousel(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_Carousel__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      listItems: props.listItems,
      spaceBetween: props.spaceBetween,
      inverted: props.inverted,
      itemPerView: props.itemPerView,
      loopSlider: props.loopSlider, children:

      props.children }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 90972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45945);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94997);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17516);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({ displayName: "Card__Wrapper", componentId: "sc-1gywtub-0" })(["border:", ";border-radius:5px;background-color:#ffffff;overflow:hidden;a{text-decoration:none;}"],
function (props) {return props.borderless ? 'none' : '1px solid #eeeeee';});









var DescriptionWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({ displayName: "Card__DescriptionWrapper", componentId: "sc-1gywtub-1" })([""]);

var RedirectTo = function RedirectTo(props) {
  var params = props.redirectTo;
  if (typeof props.redirectTo === 'string') {
    params = { href: props.redirectTo };
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({}, params), {}, { children:
      props.children })));


};

var ThumbnailSection = function ThumbnailSection(props) {
  if (props.redirectTo) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RedirectTo, { redirectTo: props.redirectTo, locale: props.locale, children:
        props.thumbnailUrl ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: props.thumbnailUrl,
          withRadius: true, children:

          props.thumbnailContent }) : /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: "/static/playlist-empty-ic.svg",
          withRadius: true, children:

          props.thumbnailContent }) }));




  }

  if (props.href) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: props.href, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: props.thumbnailUrl,
          withRadius: true, children:

          props.thumbnailContent }) }));



  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
      large: props.large,
      path: props.thumbnailUrl,
      withRadius: true, children:

      props.thumbnailContent }));


};

var TitleSection = function TitleSection(props) {
  if (props.redirectTo) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RedirectTo, { redirectTo: props.redirectTo, locale: props.locale, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle }) }));


  }
  if (props.href) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: props.href, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle }) }));


  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle });
};




















var Card = function Card(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);

  return props.large ? /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Wrapper, {
    className: props.className,
    borderless: props.borderless, children: /*#__PURE__*/



    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { flex: "0 0 407px", onClick: props.onClick, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ThumbnailSection, {
          href: props.href,
          redirectTo: props.redirectTo ? props.redirectTo : null,
          thumbnailContent: props.thumbnailContent,
          thumbnailUrl: props.thumbnailUrl,
          locale: locale,
          large: true }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { flex: "1", px: "25px", py: "20px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
          flexDirection: "column",
          justifyContent: "space-between",
          style: { height: '100%' }, children: [/*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", onClick: props.onClick, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TitleSection, {
                contentTitle: props.contentTitle,
                redirectTo: props.redirectTo,
                locale: locale }) }),


            props.contentAuthor ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentAuthor }) }) :

            null, /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children:
              props.isContentDescriptionHTML ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, {
                dangerouslySetInnerHTML: {
                  __html: props.contentDescription } }) : /*#__PURE__*/



              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentDescription }) })] }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { mx: "-10px", children:
                  props.contentLeftCardLargeSection.map(function (item, index) {return /*#__PURE__*/(
                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: "10px", children:
                        item }, index));}) }) }), /*#__PURE__*/




              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentRightCardLargeSection })] }) })] }) })] }) }) : /*#__PURE__*/







  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(Wrapper, {
    className: props.className,
    borderless: props.borderless, children: [/*#__PURE__*/



    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { onClick: props.onClick, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ThumbnailSection, {
        href: props.href,
        redirectTo: props.redirectTo,
        thumbnailContent: props.thumbnailContent,
        thumbnailUrl: props.thumbnailUrl,
        locale: locale }) }), /*#__PURE__*/


    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: "25px", py: "20px", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", onClick: props.onClick, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TitleSection, {
          href: props.href,
          contentTitle: props.contentTitle,
          redirectTo: props.redirectTo,
          locale: locale }) }),


      props.contentAuthor ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentAuthor }) }) :

      null, /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DescriptionWrapper, { mb: "10px", children:
        props.isContentDescriptionHTML ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescriptionDivStyledP */ .DY, {
          dangerouslySetInnerHTML: {
            __html: props.contentDescription } }) : /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentDescription }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentCardLeftSection }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentCardRightSection })] })] })] });




};

Card.toString = Wrapper.toString;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 73520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var _components_typography_Headings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94268);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "CollectionCard__Wrapper", componentId: "sc-5es0mh-0" })(["height:295px;border-radius:3px;transition:box-shadow 300ms ease;position:relative;overflow:hidden;&:hover{cursor:pointer;box-shadow:0 0 20px 0 #c7c7c7;}"]);












var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_typography_Headings__WEBPACK_IMPORTED_MODULE_3__.H3).withConfig({ displayName: "CollectionCard__Title", componentId: "sc-5es0mh-1" })(["position:absolute;bottom:0;left:0;display:flex;align-items:flex-end;justify-content:center;width:100%;min-height:30%;color:#fff;padding:20px 10px;background-image:linear-gradient( 180deg,rgba(255,255,255,0) 0%,rgba(2,2,2,1) 99%,#000000 100% );text-shadow:0 0 5px rgba(0,0,0,0.5);"]);



















var CollectionCard = function CollectionCard(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/".concat(props.locale, "/playlists/collections/").concat(props.slug),
      style: { textDecoration: 'none', color: 'inherit' }, children: /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Wrapper, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
          src: props.thumbnailUrl,
          alt: "",
          layout: "fill",
          objectFit: "cover" }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Title, { bold: true, children: props.name })] }) }));



};

/* harmony default export */ __webpack_exports__["Z"] = (CollectionCard);

/***/ }),

/***/ 27843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cards_PlaylistCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(38396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./ecosystems/Favoriting.tsx
var Favoriting = __webpack_require__(21158);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/TextWithIcon.js
var TextWithIcon = __webpack_require__(64370);
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(24452);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ButtonFavoritePlaylistCard.tsx








var ButtonFavoritePlaylistCard = function ButtonFavoritePlaylistCard(props) {
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);

  var handleFavoriting = /*#__PURE__*/function () {var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(onClickFavoriteHandler) {return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                onClickFavoriteHandler());case 2:case "end":return _context.stop();}}}, _callee);}));return function handleFavoriting(_x) {return _ref.apply(this, arguments);};}();


  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Favoriting/* PlaylistFavoriting */.F, { playlistId: props.playlistId, children:
      function children(_ref2) {var isPlaylistFavoritedById = _ref2.isPlaylistFavoritedById,onClickFavoriteHandler = _ref2.onClickFavoriteHandler,loading = _ref2.loading;
        if (loading) {
          return /*#__PURE__*/(
            (0,jsx_runtime.jsxs)(buttons/* StyledMaterialButton */.er, { disabled: true, children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                style: { padding: '10px' },
                size: 10,
                spinnerColor: '#7d7d7d' }),


              isPlaylistFavoritedById ? /*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                id: "metadata.saved_favorites",
                message: "Saved to favorites" }) : /*#__PURE__*/


              (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                id: "metadata.save_favorites",
                message: "Save to favorites" })] }));




        }
        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(buttons/* StyledMaterialButton */.er, {
            onClick: function onClick() {return handleFavoriting(onClickFavoriteHandler);}, children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(TextWithIcon/* default */.Z, {
              icon:
              isPlaylistFavoritedById ?
              'ygb-icon-heart-filled' :
              'ygb-icon-heart-outline',

              iconColor:
              isPlaylistFavoritedById ?
              theme.colors.primary['blue-2'] :
              theme.colors.neutrals.black,

              iconSize: '15px',
              uppercase: true, children:

              isPlaylistFavoritedById ? /*#__PURE__*/
              (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                id: "metadata.saved_favorites",
                message: "Saved to favorites" }) : /*#__PURE__*/


              (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                id: "metadata.save_favorites",
                message: "Save to favorites" }) }) }));





      } }));


};

/* harmony default export */ var components_ButtonFavoritePlaylistCard = (ButtonFavoritePlaylistCard);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./ecosystems/ButtonDeletePlaylist.js
var ButtonDeletePlaylist = __webpack_require__(67095);
// EXTERNAL MODULE: ./ecosystems/ButtonEditPlaylist.js
var ButtonEditPlaylist = __webpack_require__(43379);
// EXTERNAL MODULE: ./ecosystems/MenuItemShareModal.tsx
var MenuItemShareModal = __webpack_require__(5822);
// EXTERNAL MODULE: ./organisms/cards/Card.tsx
var Card = __webpack_require__(90972);
;// CONCATENATED MODULE: ./organisms/cards/PlaylistCard.tsx
















var Bar = styled_components_browser_esm["default"].div.withConfig({ displayName: "PlaylistCard__Bar", componentId: "sc-1vrj8xl-0" })(["position:absolute;background-color:rgba(136,191,189,0.9);right:0;top:0;bottom:0;width:100px;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);













var Meta = styled_components_browser_esm["default"].span.withConfig({ displayName: "PlaylistCard__Meta", componentId: "sc-1vrj8xl-1" })(["color:white;font-size:10px;font-weight:500;text-align:center;margin-bottom:5px;"]);

























var PlaylistCard = function PlaylistCard(props) {
  var _props$disableActionB = props.disableActionButtons,disableActionButtons = _props$disableActionB === void 0 ? false : _props$disableActionB;
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var _useState = (0,react.useState)(null),anchorElMenu = _useState[0],setAnchorElMenu = _useState[1];

  var handleOpenMenu = function handleOpenMenu(event) {
    setAnchorElMenu(event.currentTarget);
  };

  var handleCloseMenu = function handleCloseMenu() {
    setAnchorElMenu(null);
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Card/* default */.Z, {
      className: props.className,
      large: props.appearance ? props.appearance.large : null,
      redirectTo: "/".concat(locale, "/playlists/").concat(props.playlist.identifier),
      thumbnailUrl: props.playlist.thumbnailUrl,
      thumbnailContent: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(Bar, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-playlist", color: "white", fontSize: "30px" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsxs)(Meta, { children: [
          props.playlist.videoCount, ' ', /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.videos", message: "Videos" })] }), /*#__PURE__*/

        (0,jsx_runtime.jsxs)(Meta, { children: [
          props.playlist.duration, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.min" })] })] }),



      contentTitle: props.playlist.title,
      contentAuthor: props.playlist.createdBy,
      contentDescription: props.playlist.description,
      contentCardLeftSection:
      disableActionButtons ? null : /*#__PURE__*/
      (0,jsx_runtime.jsx)(components_ButtonFavoritePlaylistCard, { playlistId: props.playlist.id }),


      contentCardRightSection:
      disableActionButtons ? null : /*#__PURE__*/
      (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* StyledMaterialButton */.er, { onClick: handleOpenMenu, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-menu-hor", fontSize: "5px" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
          id: "playlist-card-menu",
          anchorEl: anchorElMenu,
          keepMounted: true,
          open: Boolean(anchorElMenu),
          onClose: handleCloseMenu, children: [/*#__PURE__*/

          (0,jsx_runtime.jsx)(ButtonEditPlaylist/* default */.Z, {
            tag: MenuItem/* default */.Z,
            playlist: {
              id: props.playlist.id,
              title: props.playlist.title,
              description: props.playlist.description,
              visibility: props.playlist.visibility,
              ownerId: props.playlist.ownerId } }), /*#__PURE__*/







          (0,jsx_runtime.jsx)(MenuItemShareModal/* default */.Z, {
            resourceIdentifier: props.playlist.identifier,
            resource: "playlists",
            playlist: {
              id: props.playlist.id,
              title: props.playlist.title,
              description: props.playlist.description,
              visibility: props.playlist.visibility,
              ownerId: props.playlist.ownerId },

            onModalClose: handleCloseMenu }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(ButtonDeletePlaylist/* default */.Z, {
            tag: MenuItem/* default */.Z,
            playlist: {
              id: props.playlist.id,
              title: props.playlist.title,
              description: props.playlist.description,
              visibility: props.playlist.visibility,
              ownerId: props.playlist.ownerId,
              videoCount: props.playlist.videoCount } })] })] }),






      contentLeftCardLargeSection:
      disableActionButtons ?
      [] :
      [/*#__PURE__*/
      (0,jsx_runtime.jsx)(components_ButtonFavoritePlaylistCard, {

        playlistId: props.playlist.id }, "1"), /*#__PURE__*/

      (0,jsx_runtime.jsx)(ButtonEditPlaylist/* default */.Z, {

        tag: buttons/* StyledMaterialButton */.er,
        playlist: {
          id: props.playlist.id,
          title: props.playlist.title,
          description: props.playlist.description,
          visibility: props.playlist.visibility,
          ownerId: props.playlist.ownerId } }, "3"), /*#__PURE__*/


      (0,jsx_runtime.jsx)(ButtonDeletePlaylist/* default */.Z, {

        tag: MenuItem/* default */.Z,
        playlist: {
          id: props.playlist.id,
          title: props.playlist.title,
          description: props.playlist.description,
          visibility: props.playlist.visibility,
          ownerId: props.playlist.ownerId,
          videoCount: props.playlist.videoCount } }, "2")


      // <ButtonScheduleModal
      //   tag={StyledMaterialButton}
      //   resource="playlist"
      //   resourceId={props.playlist.id}
      // />,
      ],

      contentRightCardLargeSection:
      disableActionButtons ? null : /*#__PURE__*/
      (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* StyledMaterialButton */.er, { onClick: handleOpenMenu, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-menu-hor", fontSize: "5px" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Menu/* default */.Z, {
          anchorEl: anchorElMenu,
          open: !!anchorElMenu,
          onClose: handleCloseMenu, children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(MenuItemShareModal/* default */.Z, {
            resourceIdentifier: props.playlist.identifier,
            resource: "playlists",
            playlist: {
              id: props.playlist.id,
              title: props.playlist.title,
              description: props.playlist.description,
              visibility: props.playlist.visibility,
              ownerId: props.playlist.ownerId } }) })] }) }));








};

/* harmony default export */ var cards_PlaylistCard = (PlaylistCard);

/***/ }),

/***/ 92913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71383);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12922);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63659);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85169);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_typography_Headings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94268);
/* harmony import */ var _components_typography_Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36225);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10842);
/* harmony import */ var _lib_apollo_policies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54734);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17516);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
var _templateObject;













var DELETE_PLAYLIST = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n  mutation deletePlaylist($id: ID!) {\n    deletePlaylist(id: $id) {\n      status {\n        destroyed\n      }\n    }\n  }\n"])));









var ConfirmDeletePlaylistModal = function ConfirmDeletePlaylistModal(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z);

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Modal */ .u_, { open: props.open, handleClose: props.handleClose, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h4, { handleClose: props.handleClose, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { as: _components_typography_Headings__WEBPACK_IMPORTED_MODULE_3__.H4, mt: "0px", mb: "0px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
              id: "confirm_delete_playlist_modal.title",
              message: 'Delete Playlist' }) }) }), /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, { pushFooterDown: 210, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 30, children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { as: _components_typography_Paragraph__WEBPACK_IMPORTED_MODULE_4__.P, mt: "0px", mb: "0px", color: "#242424", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
                id: "confirm_delete_playlist_modal.description",
                components: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("b", {}, "0")],
                values: {
                  title: props.playlistTitle,
                  videos_count: props.playlistVideoCount } }) }) }) }), /*#__PURE__*/





        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$_, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { flexDirection: "column", flex: 1, children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 10, flex: 1, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                appearance: "default-blue",
                fullWidth: true,
                onClick: props.handleClose, children: /*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
                  id: "confirm_delete_playlist_modal.no",
                  message: 'No, keep the playlist' }) }) }), /*#__PURE__*/



            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flex: 1, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_13__/* .Mutation */ .m, { mutation: DELETE_PLAYLIST, children:
                function children(deletePlaylist) {
                  return /*#__PURE__*/(
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                      fullWidth: true,
                      appearance: "outline",
                      onClick: function onClick() {
                        deletePlaylist({
                          variables: { id: props.playlistId },
                          update: function update(proxy) {
                            delete proxy.data.data[props.playlistId];
                          } }).
                        then(function () {
                          props.handleClose();
                          // I faced this issue https://github.com/zeit/next.js/issues/5947 no solution for it yet
                          window.location.href = "/".concat(locale, "/me/playlists");
                          (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_6__/* .snackbarVar */ .Ck)({
                            isSnackBarOpen: true,
                            goTo: 'NONE',
                            id: 'playlist_delete',
                            snackBarMessage: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_14__/* .i18n._ */ .ag._("playlist.playlist_deleted") });

                          (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)()._PIXEL_TRACK(
                          'delete-playlist',
                          true,
                          {
                            id: props.playlistId });


                        });
                      }, children: /*#__PURE__*/

                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
                        id: "confirm_delete_playlist_modal.yes",
                        message: 'Yes, I want to delete the playlist' }) }));



                } }) })] }) })] }) }));







};

/* harmony default export */ __webpack_exports__["Z"] = (ConfirmDeletePlaylistModal);

/***/ }),

/***/ 21793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71383);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(94471);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12922);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31157);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9128);
/* harmony import */ var _components_SectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70300);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17516);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85169);
/* harmony import */ var _organisms_cards_CollectionCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73520);
/* harmony import */ var _organisms_cards_PlaylistCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27843);
/* harmony import */ var _organisms_Carousel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8033);
/* harmony import */ var _skeletons_CardRowSkeleton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62080);
/* harmony import */ var _skeletons_CollectionRowSkeleton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95581);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47493);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37887);
/* harmony import */ var _components_EmptyResults__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87977);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);
var _templateObject, _templateObject2;




// import Grid from '@components/Grid';















var COLLECTIONS_ID = '02e12572-1156-46c7-9c0c-b05f7a7c745d';

var GET_PLAYLISTS = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  query playlists($collection: String) {\n    playlists(collection: $collection) {\n      data {\n        id\n        identifier\n        title\n        description\n        visibility\n        owner {\n          id\n          firstName\n        }\n        meta {\n          videoCount\n          minutes\n        }\n        assets {\n          thumbnailUrl\n        }\n      }\n    }\n  }\n"])));
























var GET_COLLECTIONS = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  query taxonomies($filter: String) {\n    taxonomies(filter: $filter) {\n      terms {\n        id\n        name\n        titleImageUrl\n        slug\n      }\n    }\n  }\n"])));












var Grid = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({ displayName: "playlists__Grid", componentId: "sc-1vayjgl-0" })(["display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-gap:10px;"]);





var SamplePlaylists = function SamplePlaylists() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_12__/* .UserContext */ .S),currentUser = _useContext[0];
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
  var _useQuery = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_18__/* .useQuery */ .a)(GET_PLAYLISTS, {
    variables: { collection: 'recommended-playlists' },
    fetchPolicy: 'network-only' }),loading = _useQuery.loading,data = _useQuery.data,error = _useQuery.error;


  if (error) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_EmptyResults__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, { icon: 'ygb-icon-playlist-empty-ic' });
  } else if (loading) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_skeletons_CardRowSkeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { items: [1, 2, 3], margin: "0", overviewsection: true });
  }

  var playlists = data.playlists;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "30px", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: ['15px', '15px', '15px'], px: [15, 20, 20], children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, { id: "playlists.get_started", message: 'Get Started' }),
          button:
          currentUser !== null && currentUser !== void 0 && currentUser.id ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            appearance: 'link',
            onClick: function onClick() {
              next_router__WEBPACK_IMPORTED_MODULE_0___default().push("/[lang]/me/playlists", "/".concat(

              locale, "/me/playlists"));

            }, children: /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, {
              id: "playlists.view_my_playlist",
              message: 'View My Playlists' }) }) :


          null }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: 15, pr: [0, 0, 20], pl: [0, 0, 20], children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_organisms_Carousel__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { itemPerView: 3, children:
          playlists.data.map(function (playlist) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_organisms_cards_PlaylistCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {

                playlist: {
                  id: playlist.id,
                  identifier: playlist.identifier,
                  visibility: playlist.visibility,
                  title: playlist.title,
                  description: playlist.description,
                  thumbnailUrl: playlist.assets.thumbnailUrl,
                  duration: playlist.meta.minutes,
                  videoCount: playlist.meta.videoCount,
                  createdBy: playlist.owner.firstName,
                  ownerId: playlist.owner.id } }, playlist.id));}) }) })] }));







};

var PlaylistCollections = function PlaylistCollections() {var _taxonomies$, _taxonomies$$terms, _taxonomies$$terms$ma;
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
  var _useQuery2 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_18__/* .useQuery */ .a)(GET_COLLECTIONS, {
    variables: { filter: COLLECTIONS_ID },
    ssr: false }),error = _useQuery2.error,loading = _useQuery2.loading,data = _useQuery2.data;


  if (error) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_EmptyResults__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, { icon: 'ygb-icon-playlist-empty-ic' });
  if (loading) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_skeletons_CollectionRowSkeleton__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, { animation: false });
  }
  var taxonomies = data.taxonomies;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: [15, 20, 20], children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: 15, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          title: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_19__/* .Trans */ .cC, {
            id: "playlists.browse_category",
            message: 'Browse by category' }) }) }), /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Grid, { children: (_taxonomies$ =
        taxonomies[0]) === null || _taxonomies$ === void 0 ? void 0 : (_taxonomies$$terms = _taxonomies$.terms) === null || _taxonomies$$terms === void 0 ? void 0 : (_taxonomies$$terms$ma = _taxonomies$$terms.map) === null || _taxonomies$$terms$ma === void 0 ? void 0 : _taxonomies$$terms$ma.call(_taxonomies$$terms, function (term) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_organisms_cards_CollectionCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
              thumbnailUrl: term.titleImageUrl,
              name: term.name,
              locale: locale,
              slug: term.slug },
            term.slug));}) })] }));





};

var Playlists = function Playlists() {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { flexDirection: "column", mt: [25, 30, 40], mb: [25, 30, 40], children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { title: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_20__/* .i18n._ */ .ag._("opengraph.playlists_title") }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(SamplePlaylists, {}), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(PlaylistCollections, {})] }) }));



};

/* harmony default export */ __webpack_exports__["default"] = (Playlists);

/***/ }),

/***/ 10759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94007);
/* harmony import */ var _BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30794);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var BlogCardSkeleton = function BlogCardSkeleton(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        pb: '56.25%',
        height: 0,
        as: _BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        mb: "30px",
        animation: props.animation }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        height: 10,
        width: 100,
        marginBottom: 20,
        animation: props.animation }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        height: 10,
        width: 100,
        marginBottom: 20,
        animation: props.animation }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        height: 10,
        width: 60,
        marginBottom: 20,
        animation: props.animation })] }));};




/* harmony default export */ __webpack_exports__["Z"] = (BlogCardSkeleton);

/***/ }),

/***/ 62080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31157);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32460);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _BaseSkeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30794);
/* harmony import */ var _BlogCardSkeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10759);
/* harmony import */ var _VideoCardSkeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93250);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}







var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({ displayName: "CardRowSkeleton__Box", componentId: "sc-qtbbvr-0" })(["@media (max-width:", "){min-width:", ";min-width:", ";}@media (max-width:", "){min-width:", ";}"],
function (props) {return "".concat(props.theme.viewports.tablet, "px");},
function (props) {return props.overviewsection ? '407px' : null;},
function (props) {return props.overviewblogsection ? '300px' : null;},

function (props) {return "".concat(props.theme.viewports.mobile, "px");},
function (props) {return props.overviewsection ? '300px' : null;});



var CardRowSkeleton = function CardRowSkeleton(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(Box, { style: { overflow: 'hidden' }, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: 20, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          shape: 'square',
          height: 30,
          width: 40,
          animation: props.animation }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { px: 0, ml: [-10, -10, -15], mr: [-10, -10, -15], children: [
          props.overviewsection &&
          props.items.map(function (item, index) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Box, _objectSpread(_objectSpread({
                overviewsection: props.overviewsection,

                width: props.width ? props.width : [1, 1 / props.items.length] },
              (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getMargins */ .o_)(
              index,
              props.margin ? props.margin : props.items.length,
              props.margin ? props.margin : null)), {}, {

                pr: 0,
                pl: 0,
                px: 0,
                mx: [10, 10, 15], children: /*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_VideoCardSkeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { animation: props.animation }) }), index));}),


          props.overviewblogsection &&
          props.items.map(function (item, index) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Box, _objectSpread(_objectSpread({
                overviewblogsection: props.overviewblogsection,

                width: props.width ? props.width : [1, 1 / props.items.length] },
              (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getMargins */ .o_)(
              index,
              props.margin ? props.margin : props.items.length,
              props.margin ? props.margin : null)), {}, {

                pr: 0,
                pl: 0,
                px: 0,
                mx: [10, 10, 15], children: /*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_BlogCardSkeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { animation: props.animation }) }), index));})] }) })] }));};







/* harmony default export */ __webpack_exports__["Z"] = (CardRowSkeleton);

/***/ }),

/***/ 95581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_faker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43012);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30794);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





var CollectionRowSkeleton = function CollectionRowSkeleton(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 20, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          shape: 'square',
          height: 30,
          width: 40,
          animation: props.animation }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { flexWrap: "wrap", mx: "-15px", mb: "20px", children:
        _lib_faker__WEBPACK_IMPORTED_MODULE_1__/* .items10.map */ .dz.map(function (item, index) {
          var mb = index % 5 === 0 ? 20 : 0;
          return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { width: [1, 1, 1 / 5], mb: [20, 20, mb], px: "15px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                height: 300,
                width: 100,
                animation: props.animation }) }, index));



        }) })] }));};




/* harmony default export */ __webpack_exports__["Z"] = (CollectionRowSkeleton);

/***/ }),

/***/ 93250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94007);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94997);
/* harmony import */ var _BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30794);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var Card = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "VideoCardSkeleton__Card", componentId: "sc-ch3osf-0" })(["border-radius:5px;background-color:#ffffff;border:solid 1px #eeeeee;"]);





var Content = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "VideoCardSkeleton__Content", componentId: "sc-ch3osf-1" })(["padding:15px 30px;"]);



var VideoCardSkeleton = function VideoCardSkeleton(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Card, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, { path: "", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, { as: _BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, animation: props.animation }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Content, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          height: 10,
          width: 100,
          marginBottom: 20,
          animation: props.animation }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          height: 10,
          width: 100,
          marginBottom: 20,
          animation: props.animation }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          height: 10,
          width: 60,
          marginBottom: 20,
          animation: props.animation })] })] }));};





/* harmony default export */ __webpack_exports__["Z"] = (VideoCardSkeleton);

/***/ }),

/***/ 99720:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/playlists",
      function () {
        return __webpack_require__(21793);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4568,6394,5675,4334,9382,9774,2888,179], function() { return __webpack_exec__(99720); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);